"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LogQueueFacade = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var uuid = _interopRequireWildcard(require("uuid"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogQueueFacade = exports.LogQueueFacade = function LogQueueFacade(section, meta, logService, defaultUrl) {
  var logQueue = [];
  var currentLogRequestsRunning = 0;
  var maxConcurrentLogRequests = 2;
  var sendLog = function sendLog(logWithURL) {
    currentLogRequestsRunning++;
    logService(logWithURL).catch(function (result) {
      return console.log('Failed to send client log', result);
    }).finally(function () {
      currentLogRequestsRunning--;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      processLogQueue();
    });
  };
  var processLogQueue = function processLogQueue() {
    if (currentLogRequestsRunning >= maxConcurrentLogRequests || logQueue.length === 0) return;
    var nextLog = logQueue.shift();
    if (nextLog) {
      sendLog(nextLog);
    }
  };
  var getLoggingSessionID = function getLoggingSessionID() {
    var loggingSessionID = _jsCookie.default.get('LoggingSessID');
    if (!loggingSessionID) {
      loggingSessionID = uuid.v4();
      _jsCookie.default.set('LoggingSessID', loggingSessionID);
    }
    return loggingSessionID;
  };
  var formatLog = function formatLog(logObject, logUrl) {
    var timestamp = new Date((0, _now.default)()).toUTCString();
    var finalLogUrl = logUrl || defaultUrl;
    var finalLogObject = _objectSpread(_objectSpread({}, logObject), {}, {
      timestamp: timestamp,
      sessionId: getLoggingSessionID(),
      brandId: meta.brandId,
      userId: meta.userId,
      section: section,
      userAgent: window.navigator.userAgent,
      datacenter: meta.dc
    });
    return {
      log: finalLogObject,
      url: finalLogUrl
    };
  };
  var addToLogQueue = function addToLogQueue(logObject, logUrl) {
    var formattedLog = formatLog(logObject, logUrl);
    logQueue.push(formattedLog);
    processLogQueue();
  };
  return {
    addToLogQueue: addToLogQueue
  };
};
//# sourceMappingURL=QueueFacade.js.map